import React from "react";
import PageHead from "../Head";
import Context from "@/context/Context";
import Header from "@/components/Header/Header";
import Company from "@/components/Company/Company";
import CallToAction from "@/components/CallToAction/CallToAction";
import Footer from "@/components/Footer/Footer";
import Copyright from "@/components/Footer/Copyright";
import PopupMobileMenu from "@/components/Header/PopupMobileMenu";
import Head from "next/head";

const CompanyPage = () => {
  return (
    <>
      <PageHead title="Company" description={""} />
      <main className="page-wrapper">
        <Context>
          <Header btnClass="btn-small round" />
          <PopupMobileMenu />
          <Company />
          <CallToAction />
          <Footer />
          <Copyright />
        </Context>
      </main>
    </>
  );
};

export default CompanyPage;
